import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CatalogProductsToolbarProps = {
  onCreate: () => void;
  canCreate: boolean;
};

export function CatalogProductsToolbar({
  onCreate,
  canCreate,
}: CatalogProductsToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">
          Catalog (Master Catalog)
        </h2>
        <p className="text-muted-foreground text-sm">
          ຈັດການສິນຄ້າຫຼັກຂອງແພລດຟອມ ແລ້ວຄ່ອຍມອບໃຫ້ແຕ່ລະຮ້ານ.
        </p>
      </div>
      {canCreate && (
        <Button onClick={onCreate}>
          <PlusIcon className="size-4" />
          ເພີ່ມສິນຄ້າ
        </Button>
      )}
    </div>
  );
}
